export const RETURNS_MODULE = 'RETURNS_MODULE';

export const VIEW_RETURNS = 'VIEW_RETURNS';
